module.exports = __webpack_public_path__ + "img/trims.f4661e62.svg";